import React from 'react'
import { List, Layout } from 'antd'
import { Button } from 'layout'

export default function ChatSideBarUsersList ({ visible, users }) {
  const { Sider } = Layout

  if (visible) {
    return (
      <Sider trigger={null} collapsible collapsed={!visible} style={{ background: '#CCC', color: '#666', padding: '0px 10px' }}>
        <List
          header={<div>Active chat users</div>}
          dataSource={users}
          renderItem={item => (
            <List.Item style={{ background: 'transparent', border: '0px', padding: '0px' }}>
              <Button onClick={() => console.log('clicked user', item.sid)}>{item.identity}</Button>
            </List.Item>
          )}
        />
      </Sider>
    )
  } else {
    return <></>
  }
}
